var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    className: "dark:fill-footerTextColorDark fill-footerTextColorLight transition duration-300 dark:dark:hover:fill-primaryDark hover:fill-headerMenuHoverLight",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12,24c6.6,0,12-5.4,12-12S18.6,0,12,0,0,5.4,0,12s5.4,12,12,12ZM10.7,7h-3.7v11h3.7v-2.4h1.2v1.2h1.2v1.2h3.7v-3.7h-1.2v-1.2h-1.2v-1.2h1.2v-1.2h1.2v-3.7h-3.7v1.2h-1.2v1.2h-1.2v-2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKick);
export default __webpack_public_path__ + "static/media/icon-kick.1872b4fa276de24866bddcb56e22d76b.svg";
export { ForwardRef as ReactComponent };